var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".card-input[data-v-47595e95] {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #d1d5db !important; /* Tailwind's gray-300 */\n  border-radius: 0.375rem; /* Tailwind's rounded-md */\n  color: #1f1f1f;\n}\n\n.v-select input[type=search][data-v-47595e95]{\n  border:0px !important;\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _values = require("babel-runtime/core-js/object/values");

var _values2 = _interopRequireDefault(_values);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _LocationForm = require("./LocationForm.vue");

var _LocationForm2 = _interopRequireDefault(_LocationForm);

var _UserIpAddress = require("./UserIpAddress.vue");

var _UserIpAddress2 = _interopRequireDefault(_UserIpAddress);

var _DeviceFingerprint = require("./DeviceFingerprint.vue");

var _DeviceFingerprint2 = _interopRequireDefault(_DeviceFingerprint);

var _CardLogo = require("./CardLogo.vue");

var _CardLogo2 = _interopRequireDefault(_CardLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "CollectCardDetails",
  components: { LocationForm: _LocationForm2.default, UserIpAddress: _UserIpAddress2.default, DeviceFingerprint: _DeviceFingerprint2.default, CardLogo: _CardLogo2.default },
  props: {
    selectedCard: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      isSaved: false,
      states: [],
      expiryDateValid: false,
      cvvValid: false,
      phoneNumberValid: false,
      cardDetails: {
        cardNumber: "",
        expiryDate: "",
        cvv: "",
        firstName: "",
        otherNames: "",
        email: "",
        city: "",
        state: "",
        latitude: "",
        longitude: "",
        ipAddress: "",
        fingerPrint: "",
        phoneNumber: "",
        country: "",
        billing_address: "",
        postalCode: "",
        administrative_area: "",
        locality: "",
        isSaved: null,
        transactionTimezone: ""
      },
      errors: {
        cardNumber: "",
        expiryDate: "",
        cvv: "",
        firstName: "",
        otherNames: "",
        email: "",
        city: "",
        state: "",
        phoneNumber: "",
        country: "",
        billing_address: "",
        postalCode: ""
      },
      countries: [],
      selectedCountry: {},
      country: null,
      dialCodeMenuOpen: false,
      searchQuery: "",
      filteredCountries: [],
      timeZone: "",
      realCVV: ""

    };
  },
  mounted: function mounted() {
    this.getTimezone();

    if (this.selectedCard) {
      this.prefillCardDetails();
    }
    this.fetchCountries();
  },

  computed: {
    maskedCVV: function maskedCVV() {
      return "*".repeat(this.realCVV.length);
    }
  },
  watch: {
    countries: function countries(val) {
      var _this = this;

      if (val.length > 0 && this.selectedCard.country) {
        return this.selectedCountry = val.find(function (country) {
          return country.code == _this.selectedCard.country;
        });
      } else {
        return this.selectedCountry = {};
      }
    },
    searchQuery: function searchQuery(value) {
      if (value.length > 0) {
        this.filteredCountries = this.countries.filter(function (country) {
          return country.name.toLowerCase().includes(value.toLowerCase()) || country.code.toLowerCase() == value.toLowerCase() || country.dial_code.toLowerCase() == value.toLowerCase();
        });
      } else {
        this.filteredCountries = this.countries;
      }
    }
  },
  methods: {
    handleCVVInput: function handleCVVInput(e) {
      var input = e.target.value;

      var lastLength = this.realCVV.length;
      var currentLength = input.length;

      if (currentLength > lastLength) {
        var newChar = e.data;
        if (/\d/.test(newChar) && this.realCVV.length < 4) {
          this.realCVV += newChar;
        }
      } else {
        this.realCVV = this.realCVV.slice(0, -1);
      }

      this.cardDetails.cvv = this.realCVV;

      this.validateCVV();
    },
    cancel: function cancel() {
      this.$emit("cancel");
    },
    getTimezone: function getTimezone() {
      this.timeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
    handleExpiryInput: function handleExpiryInput(event) {
      var raw = event.target.value.replace(/\D/g, "");
      if (raw.length >= 2) {
        raw = raw.slice(0, 2) + "/" + raw.slice(2, 4);
      }

      this.cardDetails.expiryDate = raw;
      this.validateExpiryDate();
    },
    prefillCardDetails: function prefillCardDetails() {
      var card = this.selectedCard;
      var formattedCardNumber = card.card_number ? card.card_number.replace(/(.{4})/g, '$1 ').trim() : '';

      var transformedCard = {
        firstName: card.first_name || '',
        otherNames: card.last_name || '',
        cardNumber: formattedCardNumber,
        expiryDate: card.expiry_month && card.expiry_year ? card.expiry_month + "/" + card.expiry_year : '',
        phoneNumber: card.msisdn || '',
        email: card.email || '',
        postalCode: card.postal_code || '',
        state: card.state,
        country: card.country,
        locality: card.city || '',
        city: card.city || ''
      };

      this.cardDetails = (0, _assign2.default)({}, this.cardDetails, transformedCard);
    },
    toggleSave: function toggleSave() {
      this.isSaved = !this.isSaved;
    },
    validateCardNumber: function validateCardNumber() {
      var raw = this.cardDetails.cardNumber.replace(/\D/g, "");

      var limited = raw.substring(0, 20);

      var formatted = limited.replace(/(\d{4})(?=\d)/g, "$1 ");

      this.cardDetails.cardNumber = formatted;

      if (!limited) {
        this.errors.cardNumber = "Card number is required";
      } else if (limited.length < 13 || limited.length > 20) {
        this.errors.cardNumber = "Invalid card number. Please check the length.";
      } else if (!/^[245]/.test(limited)) {
        this.errors.cardNumber = "We currently accept only Visa and Mastercard cards.";
      } else if (!this.isValidLuhn(limited)) {
        this.errors.cardNumber = "Invalid card number. Please check the digits.";
      } else {
        this.errors.cardNumber = "";
      }
    },
    isValidLuhn: function isValidLuhn(cardNumber) {
      var sum = 0;
      var isEven = false;

      for (var i = cardNumber.length - 1; i >= 0; i--) {
        var digit = parseInt(cardNumber.charAt(i));

        if (isEven) {
          digit *= 2;
          if (digit > 9) {
            digit -= 9;
          }
        }

        sum += digit;
        isEven = !isEven;
      }

      return sum % 10 === 0;
    },
    fetchCountries: function fetchCountries() {
      var _this2 = this;

      fetch("/iframev2/assets/json/countries.json").then(function (response) {
        return response.json();
      }).then(function (data) {
        _this2.countries = data;
        _this2.filteredCountries = data;
        _this2.parsePhoneNumber(_this2.cardDetails.phoneNumber);
      }).catch(function (error) {
        _this2.countries = [];
        _this2.filteredCountries = [];
      });
    },
    fetchStatesFilteredByCountry: function fetchStatesFilteredByCountry() {
      var _this3 = this;

      fetch("/iframev2/assets/json/states.json").then(function (response) {
        return response.json();
      }).then(function (states) {
        var filteredStates = states.filter(function (state) {
          return state.country_code === _this3.cardDetails.country.toUpperCase();
        });
        _this3.states = filteredStates.map(function (state) {
          return { value: state.name, name: state.name };
        });
      }).catch(function (error) {
        _this3.states = [];
      });
    },
    validateExpiryDate: function validateExpiryDate() {
      var expiry = this.cardDetails.expiryDate;
      var pattern = /^(0[1-9]|1[0-2])\/(\d{2})$/;
      if (!expiry) {
        this.errors.expiryDate = "Expiry date is required";
        this.expiryDateValid = false;
      } else if (!pattern.test(expiry)) {
        this.errors.expiryDate = "Invalid expiry date format";
        this.expiryDateValid = false;
      } else {
        var _expiry$split = expiry.split("/"),
            _expiry$split2 = (0, _slicedToArray3.default)(_expiry$split, 2),
            mm = _expiry$split2[0],
            yy = _expiry$split2[1];

        var month = parseInt(mm);
        var year = parseInt("20" + yy);

        var now = new Date();
        var currentYear = now.getFullYear();
        var currentMonth = now.getMonth() + 1;

        if (year < currentYear || year === currentYear && month < currentMonth) {
          this.errors.expiryDate = "The expiry date must be in the future";
          this.expiryDateValid = false;
        } else {
          this.errors.expiryDate = "";
          this.expiryDateValid = true;
        }
      }
    },
    validatePhoneNumber: function validatePhoneNumber() {
      var dialCode = this.country.dial_code.trim();
      var phone = this.cardDetails.phoneNumber.trim();

      if (!phone) {
        this.errors.phoneNumber = "Phone number is required";
        this.phoneNumberValid = false;
        return;
      }

      var cleanedCode = dialCode.replace(/\s+/g, "").replace(/^(\+)?/, "+");
      var cleanedPhone = phone.replace(/\s+/g, "");

      if (/^0|\+/.test(cleanedPhone)) {
        this.errors.phoneNumber = "Do not include + or leading 0 in phone number";
        this.phoneNumberValid = false;
        return;
      }
      var fullPhone = "" + cleanedCode + cleanedPhone;

      var pattern = /^\+?[1-9]\d{7,14}$/;
      if (pattern.test(fullPhone)) {
        this.errors.phoneNumber = "";
        this.phoneNumberValid = true;
      } else {
        this.errors.phoneNumber = "Invalid phone number format";
        this.phoneNumberValid = false;
      }
    },
    validateCVV: function validateCVV() {
      var pattern = /^\d{3,4}$/;
      if (!this.cardDetails.cvv) {
        this.errors.cvv = "CVV is required";
        this.cvvValid = false;
      } else if (!pattern.test(this.cardDetails.cvv)) {
        this.errors.cvv = "Invalid CVV";
        this.cvvValid = false;
      } else {
        this.errors.cvv = "";
        this.cvvValid = true;
      }
    },
    validateFirstName: function validateFirstName() {
      this.errors.firstName = this.cardDetails.firstName ? "" : "First name is required";
    },
    validateCountry: function validateCountry() {
      this.errors.country = this.cardDetails.country ? "" : "Country is required";
    },
    validatePostalCode: function validatePostalCode() {
      this.errors.postalCode = this.cardDetails.postalCode ? "" : "Postal code is required";
    },
    validateOtherNames: function validateOtherNames() {
      this.errors.otherNames = this.cardDetails.otherNames ? "" : "Other names are required";
    },
    validateEmail: function validateEmail() {
      var pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.cardDetails.email) {
        this.errors.email = "Email is required";
      } else if (!pattern.test(this.cardDetails.email)) {
        this.errors.email = "Invalid email address";
      } else {
        this.errors.email = "";
      }
    },
    validateCity: function validateCity() {
      this.errors.city = this.cardDetails.city ? "" : "City is required";
    },
    validateState: function validateState() {
      this.errors.state = this.cardDetails.state ? "" : "State is required";
    },
    openDialCodeMenu: function openDialCodeMenu() {
      this.dialCodeMenuOpen = !this.dialCodeMenuOpen;
    },
    closeDialCodeMenu: function closeDialCodeMenu(divId) {
      var _this4 = this;

      var dialCodeDiv = document.getElementById(divId);
      if (!dialCodeDiv) return;
      document.addEventListener('click', function (event) {
        if (!dialCodeDiv.contains(event.target)) {
          _this4.dialCodeMenuOpen = false;
        }
      });
    },
    selectCountry: function selectCountry(value) {
      this.country = value;
      this.dialCodeMenuOpen = false;
    },

    selectedCountryDialCode: function selectedCountryDialCode() {
      return this.country.dial_code || null;
    },
    onSearchInput: function onSearchInput(event) {
      this.searchQuery = event.target.value;
    },
    setStates: function setStates() {
      if (!this.selectedCountry) {
        this.errors.country = "Country is required";
        this.cardDetails.country = "";
        return;
      }
      this.errors.country = "";
      this.cardDetails.country = this.selectedCountry.code;

      if (this.selectedCountry.code === "US") {
        this.states = [{
          value: "AL",
          name: "Alabama"
        }, { value: "AK", name: "Alaska" }, { value: "AZ", name: "Arizona" }, { value: "AR", name: "Arkansas" }, { value: "CA", name: "California" }, { value: "CO", name: "Colorado" }, { value: "CT", name: "Connecticut" }, { value: "DE", name: "Delaware" }, { value: "DC", name: "District Of Columbia" }, { value: "FL", name: "Florida" }, { value: "GA", name: "Georgia" }, { value: "HI", name: "Hawaii" }, { value: "ID", name: "Idaho" }, { value: "IL", name: "Illinois" }, { value: "IN", name: "Indiana" }, { value: "IA", name: "Iowa" }, { value: "KS", name: "Kansas" }, { value: "KY", name: "Kentucky" }, { value: "LA", name: "Louisiana" }, { value: "ME", name: "Maine" }, { value: "MD", name: "Maryland" }, { value: "MA", name: "Massachusetts" }, { value: "MI", name: "Michigan" }, { value: "MN", name: "Minnesota" }, { value: "MS", name: "Mississippi" }, { value: "MO", name: "Missouri" }, { value: "MT", name: "Montana" }, { value: "NE", name: "Nebraska" }, { value: "NV", name: "Nevada" }, { value: "NH", name: "New Hampshire" }, { value: "NJ", name: "New Jersey" }, { value: "NM", name: "New Mexico" }, { value: "NY", name: "New York" }, { value: "NC", name: "North Carolina" }, { value: "ND", name: "North Dakota" }, { value: "OH", name: "Ohio" }, { value: "OK", name: "Oklahoma" }, { value: "OR", name: "Oregon" }, { value: "PA", name: "Pennsylvania" }, { value: "RI", name: "Rhode Island" }, { value: "SC", name: "South Carolina" }, { value: "SD", name: "South Dakota" }, { value: "TN", name: "Tennessee" }, { value: "TX", name: "Texas" }, { value: "UT", name: "Utah" }, { value: "VT", name: "Vermont" }, { value: "VA", name: "Virginia" }, { value: "WA", name: "Washington" }, { value: "WV", name: "West Virginia" }, { value: "WI", name: "Wisconsin" }, { value: "WY", name: "Wyoming" }, { value: "AS", name: "American Samoa" }, { value: "GU", name: "Guam" }, { value: "MP", name: "Northern Mariana Islands" }, { value: "PR", name: "Puerto Rico" }, { value: "UM", name: "Armed Forces Pacific" }, { value: "VI", name: "Virgin Islands" }];
      } else if (this.selectedCountry.code === "KE") {
        this.fetchStatesFilteredByCountry();
      } else {
        this.states = [];
      }
    },
    validateField: function validateField(fieldName) {
      switch (fieldName) {
        case "cardNumber":
          this.validateCardNumber();
          break;
        case "expiryDate":
          this.validateExpiryDate();
          break;
        case "cvv":
          this.validateCVV();
          break;
        case "firstName":
          this.validateFirstName();
          break;
        case "otherNames":
          this.validateOtherNames();
          break;
        case "email":
          this.validateEmail();
          break;
        case "city":
          this.validateCity();
          break;
        case "state":
          this.validateState();
          break;
        case "phoneNumber":
          this.validatePhoneNumber();
          break;
        case "country":
          this.validateCountry();
          break;
        case "postalCode":
          this.validatePostalCode();
          break;
      }
    },
    validateForm: function validateForm() {
      this.validateCardNumber();
      this.validateExpiryDate();
      this.validateCVV();
      this.validateFirstName();
      this.validateOtherNames();
      this.validateEmail();
      this.validateCity();
      this.validateState();
      this.validatePhoneNumber();
      this.validateCountry();
      this.validatePostalCode();

      return (0, _values2.default)(this.errors).every(function (err) {
        return err === "";
      });
    },
    setLocation: function setLocation(location) {
      this.cardDetails.latitude = location.latitude;
      this.cardDetails.longitude = location.longitude;
    },
    getUserIp: function getUserIp(ipAddress) {
      this.cardDetails.ipAddress = ipAddress;
    },
    getFingerprint: function getFingerprint(fingerprint) {
      this.cardDetails.fingerPrint = fingerprint;
    },
    parsePhoneNumber: function parsePhoneNumber(phoneNumber) {
      if (!phoneNumber) {
        this.country = this.countries.find(function (elem) {
          return elem.code == "KE";
        });
        return;
      }

      var cleaned = phoneNumber.toString().replace(/\D/g, '');
      var sortedCountries = this.countries.sort(function (a, b) {
        return b.dial_code.replace('+', '').length - a.dial_code.replace('+', '').length;
      });

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(sortedCountries), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var country = _step.value;

          var dialCode = country.dial_code.replace('+', '');
          if (cleaned.startsWith(dialCode) && cleaned.length > dialCode.length) {
            this.cardDetails.phoneNumber = cleaned.substring(dialCode.length);
            this.country = country;
            return;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.country = this.countries.find(function (elem) {
        return elem.code == "KE";
      });
    },
    onSubmit: function onSubmit() {
      var isValid = this.validateForm();
      if (!isValid) return;
      var stateValue = (0, _typeof3.default)(this.cardDetails.state) === 'object' ? this.cardDetails.state.name : this.cardDetails.state;

      this.cardDetails.state = stateValue;
      this.cardDetails.administrative_area = stateValue;
      this.cardDetails.locality = this.cardDetails.city;
      this.cardDetails.isSaved = this.isSaved;
      this.cardDetails.transactionTimezone = this.timeZone;

      this.cardDetails.billing_address = this.cardDetails.city + ", " + this.cardDetails.state;
      this.cardDetails.phoneNumber = this.country.dial_code.replace('+', '') + this.cardDetails.phoneNumber;

      this.$emit("collectedCardDetails", this.cardDetails);

      this.cardDetails = {
        cardNumber: "",
        expiryDate: "",
        cvv: "",
        firstName: "",
        otherNames: "",
        email: "",
        city: "",
        state: "",
        latitude: "",
        longitude: "",
        ipAddress: "",
        fingerPrint: "",
        phoneNumber: "",
        country: "",
        billing_address: "",
        postalCode: "",
        administrative_area: "",
        locality: ""
      };
      this.errors = {};
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col gap-5 h-full mx-px"},[_c('form',{staticClass:"w-full mx-auto space-y-6",on:{"copy":function($event){$event.preventDefault();},"paste":function($event){$event.preventDefault();},"cut":function($event){$event.preventDefault();},"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('h2',{staticClass:"text-base font-semibold font-['Inter'] text-[#1f1f1f]"},[_vm._v("Enter Card details")]),_vm._v(" "),_c('div',{staticClass:"grid grid-cols-1 sm:grid-cols-2 gap-4 h-fit"},[_c('div',{staticClass:"col-span-full"},[_c('label',{staticClass:"block text-xs font-medium font-['Inter'] text-[#1f1f1f] mb-1"},[_vm._v("Card number")]),_vm._v(" "),_c('div',{staticClass:"relative"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardDetails.cardNumber),expression:"cardDetails.cardNumber"}],staticClass:"flex-1 w-full bg-transparent text-sm font-['Inter'] focus:outline-none card-input",attrs:{"type":"text"},domProps:{"value":(_vm.cardDetails.cardNumber)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.cardDetails, "cardNumber", $event.target.value)},function($event){return _vm.validateField('cardNumber')}]}}),_vm._v(" "),_c('div',{staticClass:"flex absolute right-[-2px] top-2 gap-1 items-center justify-end"},[_c('CardLogo',{attrs:{"cardNumber":_vm.cardDetails.cardNumber}})],1)]),_vm._v(" "),(_vm.errors.cardNumber)?_c('form-error',{attrs:{"message":_vm.errors.cardNumber}}):_vm._e()],1),_vm._v(" "),_c('div',[_c('label',{staticClass:"block text-xs font-medium font-['Inter'] text-[#1f1f1f] mb-1"},[_vm._v("Expiry date")]),_vm._v(" "),_c('div',{staticClass:"relative"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardDetails.expiryDate),expression:"cardDetails.expiryDate"}],staticClass:"flex-1 w-full bg-transparent text-sm font-['Inter'] focus:outline-none card-input",attrs:{"type":"text","placeholder":"MM/YY"},domProps:{"value":(_vm.cardDetails.expiryDate)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.cardDetails, "expiryDate", $event.target.value)},_vm.handleExpiryInput]}}),_vm._v(" "),(_vm.expiryDateValid)?_c('div',{staticClass:"flex absolute right-2 top-2.5 gap-1 items-center justify-end"},[_c('svg',{attrs:{"width":"19","height":"18","viewBox":"0 0 19 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M17.3232 8.9668C17.3232 10.4381 16.9112 11.831 16.1854 13.0081C14.8317 15.2838 12.3403 16.814 9.47607 16.814C6.61186 16.814 4.12042 15.2838 2.76678 13.0081C2.04092 11.831 1.62891 10.4381 1.62891 8.9668C1.62891 4.63124 5.14051 1.11963 9.47607 1.11963C13.8116 1.11963 17.3232 4.63124 17.3232 8.9668Z","stroke":"#27AE60","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6.41797 8.966L8.36012 10.9082L12.5388 7.04346","stroke":"#27AE60","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])]):_vm._e()]),_vm._v(" "),(_vm.errors.expiryDate)?_c('form-error',{attrs:{"message":_vm.errors.expiryDate}}):_vm._e()],1),_vm._v(" "),_c('div',[_c('label',{staticClass:"block text-xs font-medium font-['Inter'] text-[#1f1f1f] mb-1"},[_vm._v("CVC/CVV")]),_vm._v(" "),_c('div',{staticClass:"relative"},[_c('input',{staticClass:"flex-1 w-full bg-transparent text-sm font-['Inter'] focus:outline-none card-input",attrs:{"type":"text","placeholder":"...","maxlength":"4","autocomplete":"off"},domProps:{"value":_vm.maskedCVV},on:{"input":_vm.handleCVVInput}}),_vm._v(" "),_c('div',{staticClass:"flex absolute right-2 top-2 gap-1 items-center justify-end"},[(_vm.cvvValid)?_c('svg',{attrs:{"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.98828 8.05029H11.5716","stroke":"#27AE60","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5.32227 14.7168H6.98893","stroke":"#27AE60","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M9.07227 14.7168H12.4056","stroke":"#27AE60","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M18.6549 10.1583V14.3916C18.6549 17.3166 17.9133 18.05 14.9549 18.05H5.68828C2.72995 18.05 1.98828 17.3166 1.98828 14.3916V7.54163C1.98828 4.61663 2.72995 3.8833 5.68828 3.8833H11.5716","stroke":"#27AE60","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M14.0723 5.96663L15.3223 7.21663L18.6556 3.8833","stroke":"#27AE60","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})]):_c('svg',{attrs:{"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M2.65039 7.88965H12.2337","stroke":"#D6DEFF","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5.98438 14.5566H7.65104","stroke":"#D6DEFF","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M9.73438 14.5566H13.0677","stroke":"#D6DEFF","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_vm._v(" "),_c('path',{attrs:{"d":"M19.3171 9.99863V14.232C19.3171 17.157 18.5754 17.8903 15.6171 17.8903H6.35039C3.39206 17.8903 2.65039 17.157 2.65039 14.232V7.38197C2.65039 4.45697 3.39206 3.72363 6.35039 3.72363H12.2337","stroke":"#D6DEFF","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])])]),_vm._v(" "),(_vm.errors.cvv)?_c('form-error',{attrs:{"message":_vm.errors.cvv}}):_vm._e()],1),_vm._v(" "),_c('div',[_c('label',{staticClass:"block text-xs font-medium font-['Inter'] text-[#1f1f1f] mb-1"},[_vm._v("First Name")]),_vm._v(" "),_c('div',{staticClass:"relative"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardDetails.firstName),expression:"cardDetails.firstName"}],staticClass:"flex-1 w-full bg-transparent text-sm font-['Inter'] focus:outline-none card-input",attrs:{"type":"text"},domProps:{"value":(_vm.cardDetails.firstName)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.cardDetails, "firstName", $event.target.value)},function($event){return _vm.validateField('firstName')}]}})]),_vm._v(" "),(_vm.errors.firstName)?_c('form-error',{attrs:{"message":_vm.errors.firstName}}):_vm._e()],1),_vm._v(" "),_c('div',[_c('label',{staticClass:"block text-xs font-medium font-['Inter'] text-[#1f1f1f] mb-1"},[_vm._v("Other Name(s)")]),_vm._v(" "),_c('div',{staticClass:"relative"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardDetails.otherNames),expression:"cardDetails.otherNames"}],staticClass:"flex-1 w-full bg-transparent text-sm font-['Inter'] focus:outline-none card-input",attrs:{"type":"text"},domProps:{"value":(_vm.cardDetails.otherNames)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.cardDetails, "otherNames", $event.target.value)},function($event){return _vm.validateField('otherNames')}]}})]),_vm._v(" "),(_vm.errors.otherNames)?_c('form-error',{attrs:{"message":_vm.errors.otherNames}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-span-full"},[_c('label',{staticClass:"block text-xs font-medium font-['Inter'] text-[#1f1f1f] mb-1"},[_vm._v("Email Address")]),_vm._v(" "),_c('div',{staticClass:"relative"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardDetails.email),expression:"cardDetails.email"}],staticClass:"flex-1 w-full bg-transparent text-sm font-['Inter'] focus:outline-none card-input",attrs:{"type":"email"},domProps:{"value":(_vm.cardDetails.email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.cardDetails, "email", $event.target.value)},function($event){return _vm.validateField('email')}]}})]),_vm._v(" "),(_vm.errors.email)?_c('form-error',{attrs:{"message":_vm.errors.email}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-span-full"},[_c('label',{staticClass:"block text-xs font-medium font-['Inter'] text-[#1f1f1f] mb-1",attrs:{"for":"phoneNumber"}},[_vm._v("\n\t\t\t\t\t\tPhone number\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"flex items-center border border-[#D0D5DD] mt-1 rounded-[10px] bg-white"},[_c('div',{staticClass:"relative inline-block text-left max-w-[100px] h-full",attrs:{"id":"dial-code-menu"}},[_c('button',{staticClass:"flex justify-between items-center gap-2 text-sm font-semibold text-gray-900 py-3 px-2 overflow-hidden max-h-[38px]",attrs:{"type":"button","id":"menu-button","aria-haspopup":"true"},on:{"click":function($event){return _vm.openDialCodeMenu()}}},[_c('div',{staticClass:"flex items-center gap-2"},[_c('span',{staticClass:"size-5 bg-cover bg-no-repeat bg-center text-sm"},[_vm._v(_vm._s(_vm.country != null ?
										_vm.country.emoji
										: ""))]),_vm._v(" "),_c('span',{staticClass:"truncate whitespace-nowrap text-[#667084] text-sm font-normal leading-normal"},[_vm._v(_vm._s(_vm.country != null ? _vm.country.dial_code : ""))])]),_vm._v(" "),_c('div',{staticClass:"size-5"},[_c('svg',{class:{
										'duration-300 text-gray-400 rotate-180': _vm.dialCodeMenuOpen,
									},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"}},[_c('path',{attrs:{"d":"M5 7.5L10 12.5L15 7.5","stroke":"#667085","stroke-width":"1.66667","stroke-linecap":"round","stroke-linejoin":"round"}})])])]),_vm._v(" "),(_vm.dialCodeMenuOpen)?_c('div',{staticClass:"absolute z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none min-w-60 overflow-hidden",attrs:{"role":"menu","aria-orientation":"vertical","aria-labelledby":"menu-button"}},[_c('div',{staticClass:"p-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200 text-sm text-primary-300 text-[#1f1f1f]",attrs:{"type":"text","placeholder":"Search countries by name or code..."},domProps:{"value":(_vm.searchQuery)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value},_vm.onSearchInput],"keyup":_vm.onSearchInput,"keydown":_vm.onSearchInput,"change":_vm.onSearchInput}})]),_vm._v(" "),_c('div',{staticClass:"overflow-x-auto mb-2 h-[300px] scrollbar divide-y divide-gray-100"},_vm._l((_vm.filteredCountries),function(country,index){return _c('div',{key:index},[_c('div',{staticClass:"w-full px-4 py-2 text-left flex gap-2 items-center text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 cursor-pointer duration-300",on:{"click":function($event){return _vm.selectCountry(country)}}},[_c('span',{staticClass:"text-base rounded-full overflow-hidden"},[_vm._v(_vm._s(country.emoji))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(country.dial_code)+" "+_vm._s(country.name))])])])}),0)]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardDetails.phoneNumber),expression:"cardDetails.phoneNumber"}],staticClass:"flex-1 w-full bg-transparent text-sm font-['Inter'] focus:outline-none !border-0 !border-[#d1d5db] !rounded-[10px] !rounded-l-none !border-l text-[#1f1f1f]",attrs:{"type":"tel","name":"phoneNumber","id":"phone_number","minlength":"9","placeholder":"700 000 000"},domProps:{"value":(_vm.cardDetails.phoneNumber)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.cardDetails, "phoneNumber", $event.target.value)},function($event){return _vm.validateField('phoneNumber')}]}})]),_vm._v(" "),(_vm.errors.phoneNumber)?_c('form-error',{attrs:{"message":_vm.errors.phoneNumber}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"block text-xs font-medium font-['Inter'] text-[#1f1f1f] mb-1"},[_vm._v("Country")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.countries,"label":"name","auto":""},on:{"change":function($event){return _vm.setStates()}},model:{value:(_vm.selectedCountry),callback:function ($$v) {_vm.selectedCountry=$$v},expression:"selectedCountry"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardDetails.country),expression:"cardDetails.country"}],attrs:{"type":"hidden"},domProps:{"value":(_vm.cardDetails.country)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cardDetails, "country", $event.target.value)}}}),_vm._v(" "),(_vm.errors.country)?_c('form-error',{attrs:{"message":_vm.errors.country}}):_vm._e()],1),_vm._v(" "),_c('div',[_c('label',{staticClass:"block text-xs font-medium font-['Inter'] text-[#1f1f1f] mb-1"},[_vm._v("Postal Code")]),_vm._v(" "),_c('div',{staticClass:"relative"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardDetails.postalCode),expression:"cardDetails.postalCode"}],staticClass:"flex-1 w-full bg-transparent text-sm font-['Inter'] focus:outline-none card-input",attrs:{"type":"text","placeholder":"","maxlength":"9"},domProps:{"value":(_vm.cardDetails.postalCode)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.cardDetails, "postalCode", $event.target.value)},function($event){return _vm.validateField('postalCode')}]}})]),_vm._v(" "),(_vm.errors.postalCode)?_c('form-error',{attrs:{"message":_vm.errors.postalCode}}):_vm._e()],1),_vm._v(" "),_c('div',[_c('label',{staticClass:"block text-xs font-medium font-['Inter'] text-[#1f1f1f] mb-1"},[_vm._v("State")]),_vm._v(" "),_c('div',{staticClass:"relative"},[(_vm.cardDetails.country && _vm.states && _vm.states.length > 0)?_c('v-select',{attrs:{"options":_vm.states,"label":"name","required":"","dense":"","outlined":"","clearable":""},on:{"input":function($event){return _vm.validateField('state')}},model:{value:(_vm.cardDetails.state),callback:function ($$v) {_vm.$set(_vm.cardDetails, "state", $$v)},expression:"cardDetails.state"}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardDetails.state),expression:"cardDetails.state"}],staticClass:"flex-1 w-full bg-transparent text-sm font-['Inter'] focus:outline-none card-input",attrs:{"type":"text","maxlength":"19","placeholder":""},domProps:{"value":(_vm.cardDetails.state)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.cardDetails, "state", $event.target.value)},function($event){return _vm.validateField('state')}]}})],1),_vm._v(" "),(_vm.errors.state)?_c('form-error',{attrs:{"message":_vm.errors.state}}):_vm._e()],1),_vm._v(" "),_c('div',[_c('label',{staticClass:"block text-xs font-medium font-['Inter'] text-[#1f1f1f] mb-1"},[_vm._v("City")]),_vm._v(" "),_c('div',{staticClass:"relative"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardDetails.city),expression:"cardDetails.city"}],staticClass:"flex-1 w-full bg-transparent text-sm font-['Inter'] focus:outline-none card-input",attrs:{"type":"text","placeholder":"","maxlength":"10"},domProps:{"value":(_vm.cardDetails.city)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.cardDetails, "city", $event.target.value)},function($event){_vm.cardDetails.city = _vm.cardDetails.city.replace(/[^a-zA-Z\s'-]/g, '')}],"blur":_vm.validateCity}})]),_vm._v(" "),(_vm.errors.city)?_c('form-error',{attrs:{"message":_vm.errors.city}}):_vm._e()],1)]),_vm._v(" "),_c('LocationForm',{on:{"location":_vm.setLocation}}),_vm._v(" "),_c('UserIpAddress',{on:{"ip-address":_vm.getUserIp}}),_vm._v(" "),_c('DeviceFingerprint',{on:{"fingerprint":_vm.getFingerprint}}),_vm._v(" "),_c('div',{staticClass:"flex items-center gap-3 ml-1"},[_c('button',{class:[
            'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-1 focus:ring-[#4374F0] focus:ring-offset-2',
            _vm.isSaved ? 'bg-[#4374F0]' : 'bg-gray-200' ],attrs:{"type":"button","role":"switch","aria-checked":_vm.isSaved},on:{"click":_vm.toggleSave}},[_c('span',{class:[
              'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
              _vm.isSaved ? 'translate-x-5' : 'translate-x-0' ],attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',{staticClass:"text-sm font-medium text-gray-900"},[_vm._v("\n          Save this card details.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"flex justify-between gap-4 flex-col-reverse lg:flex-row"},[_c('button',{staticClass:"flex-1 btn-outline",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"flex-1 btn-primary w-full py-2 rounded-md text-sm font-medium font-['Inter'] disabled:cursor-not-allowed",attrs:{"type":"submit"}},[_vm._v("\n          Next\n        ")])])],1)])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-47595e95"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-47595e95", __vue__options__)
  } else {
    hotAPI.reload("data-v-47595e95", __vue__options__)
  }
})()}